import React from 'react'
import { Link } from 'react-router-dom'
import ViewIcon from 'Assets/Images/icons/view'

export const LinkViewUnstyled = props => (
  <Link
    className={`${props.className} link-view`}
    to={props.to}
    onClick={props.onClick}
  >
    <ViewIcon />
    {props.label}
  </Link>
)



// WEBPACK FOOTER //
// ./src/Components/Link/View/unstyled.js